import React from "react";
import { TextWithDividerLine } from "@qgiv/core-donor";
import ConnectedApplePayPaymentMethod from "./ConnectedApplePayPaymentMethod";
import ConnectedUseADifferentPaymentMethodButton from "./ConnectedUseADifferentPaymentMethodButton";
import ConnectedPayPalSDKScriptProvider from "./ConnectedPayPalSDKScriptProvider";
import ConnectedPayPalAuthenticatedMessage from "./ConnectedPayPalAuthenticatedMessage";

/**
 * @param {object} props
 * @param {boolean} props.displayApplePayPaymentMethod
 * @param {boolean} props.displayOrText
 * @param {boolean} props.displayPayPalSDKScriptProvider
 * @param {boolean} props.displayPayPalAuthenticatedMessage
 * @param {boolean} props.displayUseADifferentPaymentMethodButton
 * @returns {React.ReactElement}
 */
const DigitalWalletPaymentOptions = ({
    displayApplePayPaymentMethod = false,
    displayOrText = false,
    displayPayPalAuthenticatedMessage = false,
    displayPayPalSDKScriptProvider = false,
    displayUseADifferentPaymentMethodButton = false,
}) => {
    const displayCallout =
        displayApplePayPaymentMethod ||
        displayPayPalSDKScriptProvider ||
        displayPayPalAuthenticatedMessage;

    // Adds 15 px of margin below the Apple Pay button if the PayPal button is
    // also present
    return (
        <div className="col--12 -padding-left--0 -text--center">
            {displayCallout && (
                <div className="-callout qg-vendor-digital-wallet-container">
                    {displayApplePayPaymentMethod && (
                        <div className="qg-vendor-apple-pay-button">
                            <ConnectedApplePayPaymentMethod />
                        </div>
                    )}
                    {displayPayPalSDKScriptProvider && (
                        <div className="qg-vendor-paypal-venmo-buttons">
                            <ConnectedPayPalSDKScriptProvider />
                        </div>
                    )}
                    {displayPayPalAuthenticatedMessage && (
                        <ConnectedPayPalAuthenticatedMessage />
                    )}
                </div>
            )}
            {displayOrText && (
                <div className="qg-vendor-digital-wallet-divider">
                    <TextWithDividerLine text="or" />
                </div>
            )}
            {displayUseADifferentPaymentMethodButton && (
                <div className="col col--12 -padding-left--0">
                    <ConnectedUseADifferentPaymentMethodButton />
                </div>
            )}
        </div>
    );
};

export default DigitalWalletPaymentOptions;
